import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  greetings: localStorage.getItem('persons') && JSON.parse(localStorage.getItem('persons'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/persons/index.js